import script from "./loginTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./loginTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./loginTreasureView.vue?vue&type=style&index=0&id=0398d964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0398d964"]])

export default __exports__